/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import api from "./ApiService";

const BASE_PATH = `${process.env.REACT_APP_API_BASE_URL}/Mers/MersInvestor`;

const getMersInvestors = () => {
  return api.get<any>(BASE_PATH).then((response: any) => response);
};

const createMersInvestor = (data: any) => {
  return api.post<any>(BASE_PATH, data).then((response: any) => response);
};

const updateMersInvestor = (data: any) => {
  return api.put<any>(BASE_PATH, data).then((response: any) => response);
};

const MersInvestorService = {
  getMersInvestors,
  createMersInvestor,
  updateMersInvestor,
};

export default MersInvestorService;